import React from "react";
import { Switch, FormControlLabel } from "@material-ui/core";
import { useAppContext } from "../../context/AppContext";
import strings from "../../strings";

const DemoModeSwitch = () => {
  const { isDemoMode, setDemoMode, demoModeFeatureActive } = useAppContext();
  const st = strings.DEMO_MODE

  if(!demoModeFeatureActive) return null;

  return (
    <FormControlLabel
      control={<Switch checked={isDemoMode} onChange={()=>{setDemoMode(!isDemoMode)}} color="primary" />}
      label={st.DEMO_MODE}
      labelPlacement="start"
    />
  );
};

export default DemoModeSwitch;
